import baseOptions from './baseOptions';
import buildDrillDown from '../../../buildDrillDown';
import abbreviateNumber from '../../../utils/abbreviateNumber';
import { ChartColors } from '../../../theme/tokens';

// Waterfall renders a single metric broken down by a dimension, where each
// category is a delta building up to a final "Total" sum point. It reuses the
// categories x single-series data produced by toBarSeries. Requires the
// highcharts-more module (already registered in Chart.tsx).
const waterfall = ({
  title,
  openMenu,
  groupField,
  fieldType,
  chartDef,
  showDataLabels,
  fontSize,
  formatMetric,
  dateScope,
}) => ({
  ...baseOptions(formatMetric),
  chart: {
    ...baseOptions(formatMetric).chart,
    marginTop: 24,
    type: 'waterfall',
  },
  title: {
    ...baseOptions(formatMetric).title,
    text: title,
  },
  legend: {
    ...baseOptions(formatMetric).legend,
    enabled: false,
  },
  yAxis: [
    {
      ...baseOptions(formatMetric).yAxis[0],
      title: {
        enabled: false,
      },
    },
  ],
  plotOptions: {
    waterfall: {
      color: ChartColors[0],
      upColor: ChartColors[0],
      negativeColor: ChartColors[1],
      borderWidth: 0,
      dataLabels: {
        enabled: !!showDataLabels,
        color: 'var(--color-text-primary)',
        formatter: function () {
          const { y, series } = this;
          const { metricId } = series.userOptions;
          const abbreviated = abbreviateNumber(y);
          const formattedY = formatMetric({
            metricId,
            value: abbreviated ? abbreviated.abbreviated : y,
          }).trim();
          return `<b>${formattedY}</b>`;
        },
        style: {
          fontSize,
          textOutline: 'none',
        },
      },
    },
    series: {
      allowPointSelect: true,
      point: {
        events: {
          click: function (e) {
            const selectedIndex = e.point.x;
            const terms = e.point.series.data;
            if (openMenu) {
              const { metricIds } = this.series.userOptions;
              const selectedTerm = terms.find(
                (t, index) => index === selectedIndex,
              );
              if (!selectedTerm || selectedTerm.isSum) {
                return;
              }
              openMenu(
                metricIds,
                buildDrillDown(
                  groupField,
                  fieldType,
                  selectedTerm.category,
                  chartDef,
                  dateScope,
                ),
              );
            } else {
              const { onDrillDown } = this.series.userOptions;
              if (!onDrillDown) {
                alert('Coming soon...');
                return;
              }
              const selectedTerm = terms.find(
                (t, index) => index === selectedIndex,
              );
              if (selectedTerm && !selectedTerm.isSum) {
                onDrillDown(
                  selectedTerm.name || selectedTerm.category,
                  e.ctrlKey || e.metaKey,
                );
              }
            }
          },
        },
      },
    },
  },
  tooltip: {
    ...baseOptions(formatMetric).tooltip,
    shared: false,
    pointFormatter: function () {
      const { metricId } = this.series.userOptions;
      const formattedY = formatMetric({ value: this.y, metricId });
      // NOTE: Inline styles in Highcharts tooltips cannot use CSS variables.
      return `<span style="color:${this.color}">● </span><span style="color: var(--color-text-muted);">${this.series.name}: </span><b>${formattedY}</b><br/>`;
    },
  },
});

export default waterfall;
